// extracted by mini-css-extract-plugin
module.exports = {"mobileNavLink":"mobileNavLink_mobileNavLink__Bew13","mobileNavLink_active":"mobileNavLink_mobileNavLink_active__HednU"};